var OrientationMode = /** @class */ (function () {
    function OrientationMode() {
    }
    /**
     *
     */
    OrientationMode.DEFAULT = 'default';
    /**
     *
     */
    OrientationMode.CAMERA_PLANE = 'cameraPlane';
    /**
     *
     */
    OrientationMode.CAMERA_POSITION = 'cameraPosition';
    return OrientationMode;
}());
export { OrientationMode };
